import React from "react";
import { Snackbar, Alert } from "@mui/material";

class InternetConnectionDetector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSlowConnection: false,
      effectiveType: navigator.connection?.effectiveType || "unknown",
      downlink: navigator.connection?.downlink || 0,
      rtt: navigator.connection?.rtt || 0,
      avgLatency: null,
      browserSupportsAPI: !!navigator.connection,
      openSnackbar: false,
      alertMessage: "",
      alertType: "success", // "success" | "warning"
    };
    this.pingInterval = null;
  }

  componentDidMount() {
    if (this.state.browserSupportsAPI) {
      this.checkConnectionQuality();
      navigator.connection.addEventListener("change", this.handleConnectionChange);
    } else {
      // Safari / Firefox fallback → latency test
      this.startLatencyCheck();
    }
  }

  componentWillUnmount() {
    if (this.state.browserSupportsAPI) {
      navigator.connection.removeEventListener("change", this.handleConnectionChange);
    }
    if (this.pingInterval) {
      clearInterval(this.pingInterval);
    }
  }

  handleConnectionChange = () => {
    this.checkConnectionQuality();
  };

  showAlert = (type, message) => {
    this.setState({
      openSnackbar: true,
      alertType: type,
      alertMessage: message,
    });
  };

  checkConnectionQuality = () => {
    const conn = navigator.connection;
    console.log("Connection info:", conn);
    if (conn) {
      const isSlow =
        conn.effectiveType === "2g" ||
        conn.effectiveType === "slow-2g" ||
        conn.downlink < 1.5;

      this.setState({
        isSlowConnection: isSlow,
        effectiveType: conn.effectiveType,
        downlink: conn.downlink,
        rtt: conn.rtt,
      });
      if (isSlow) {
        this.showAlert("warning", "Your internet connection is slow or unstable.");
      } else {
        console.log("success", "Your internet connection is stable.");
      }
    }
  };

  /**
   * Safari / Firefox Fallback:
   * Measure latency by fetching a tiny resource repeatedly.
   */
  startLatencyCheck = () => {
    // const testURL = "https://www.google.com/favicon.ico";  // small and cached but not supported on firefox maybe due to CORS, hence replaced it with follwoing
    const testURL = "https://www.cloudflare.com/cdn-cgi/trace"; // lightweight and cached
    const intervalMs = 10000; // check every 10 seconds
    const samples = [];

    const checkLatency = async () => {
      const start = performance.now();
      try {
        // await fetch(testURL, { method: "HEAD", cache: "no-cache" });
        // Avoid HEAD requests (blocked by CORS in Firefox): Firefox blocks fetch() HEAD requests to Google’s favicon (due to CORS restrictions and mixed content blocking). Using GET instead.
        const response = await fetch(testURL, { method: "GET", cache: "no-store" });
        console.log("internet check response:", response);
        if (!response.ok) throw new Error("Network response not ok");
        const latency = performance.now() - start;
        samples.push(latency);
        if (samples.length > 5) samples.shift(); // keep last 5 samples
        const avgLatency =
          samples.reduce((a, b) => a + b, 0) / samples.length;

        // Consider slow if average latency > 800 ms
        const isSlow = avgLatency > 800;

        this.setState({ avgLatency: Math.round(avgLatency), isSlowConnection: isSlow });
        if (isSlow) {
          this.showAlert("warning", "Your internet connection is slow or unstable.");
        } else {
          // this.showAlert("success", "Your internet connection is stable.");
          console.log("success", "Your internet connection is stable.");
        }
      } catch {
        // On network error, mark as slow
        // this.setState({ isSlowConnection: true, avgLatency: null });
        this.showAlert("warning", "Unable to detect internet connection — possible network issue.");
      }
    };

    // First check immediately
    checkLatency();
    // Repeat periodically
    this.pingInterval = setInterval(checkLatency, intervalMs);
  };

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  render() {
    const { openSnackbar, alertMessage, alertType } = this.state;

    // return (
    //   <div style={{ padding: 20 }}>
    //     <h2>Network Connection Info</h2>

    //     {browserSupportsAPI ? (
    //       <>
    //         <p><b>Connection Type:</b> {effectiveType}</p>
    //         <p><b>Speed:</b> {downlink} Mbps</p>
    //         <p><b>Latency:</b> {rtt} ms</p>
    //       </>
    //     ) : (
    //       <>
    //         <p><b>Estimated Latency:</b> {avgLatency ? `${avgLatency} ms` : "Measuring..."}</p>
    //         <p><b>Detection Mode:</b> Fallback (Ping test)</p>
    //       </>
    //     )}

    //     {isSlowConnection && (
    //       <div style={styles.warningBanner}>
    //         ⚠️ Your connection seems slow or unstable.
    //       </div>
    //     )}
    //   </div>
    // );
   return (
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={this.handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={this.handleCloseSnackbar} severity={alertType} sx={{ width: "100%" }}>
          {alertMessage}
        </Alert>
      </Snackbar>
    );
  }
}

const styles = {
  warningBanner: {
    background: "#ffcc00",
    color: "#000",
    padding: "10px",
    textAlign: "center",
    borderRadius: "8px",
    marginTop: "10px",
    fontWeight: "bold",
  },
};

export default InternetConnectionDetector;
